import type { LucideIcon } from 'lucide-react'
import { Clapperboard, FileText, Sparkles } from 'lucide-react'

import {
  isFeatureEnabled,
  type TenantFeatureKey,
  type TenantFeatures,
} from '@/constants/tenant-features'

export type StudioModeKey = 'production' | 'writer' | 'creative'

export interface StudioModeNavItem {
  key: StudioModeKey
  to: string
  icon: LucideIcon
  titleKey: string
  subtitleKey: string
  feature: TenantFeatureKey
}

export const STUDIO_MODE_NAV_ITEMS: StudioModeNavItem[] = [
  {
    key: 'production',
    to: '/studio/productions',
    icon: Clapperboard,
    titleKey: 'modeHub.productionTitle',
    subtitleKey: 'modeHub.productionSubtitle',
    feature: 'studio_production',
  },
  {
    key: 'writer',
    to: '/studio/writer',
    icon: FileText,
    titleKey: 'modeHub.writerTitle',
    subtitleKey: 'modeHub.writerSubtitle',
    feature: 'studio_writer',
  },
  {
    key: 'creative',
    to: '/studio/creative',
    icon: Sparkles,
    titleKey: 'modeHub.creativeTitle',
    subtitleKey: 'modeHub.creativeSubtitle',
    feature: 'studio_creative',
  },
]

export function visibleStudioModeNavItems(features: TenantFeatures): StudioModeNavItem[] {
  return STUDIO_MODE_NAV_ITEMS.filter((item) => isFeatureEnabled(features, item.feature))
}

export function firstVisibleStudioModePath(features: TenantFeatures): string {
  return visibleStudioModeNavItems(features)[0]?.to ?? '/'
}
